// src/utilsLogic/pamphletProcessor.js

export const processPamphlet = async (formData, planData, formType) => {
    debugger
  const fullPayload = {
    user: {
      name: formData.name,
      email: formData.email || null,
      phone: formData.phone || null,
      newsletter: formData.newsletter,
      contactMethod: formType,
    },
    selection: planData,
    submittedAt: new Date().toISOString(),
  };

  // Simulate pamphlet generation
  await new Promise((resolve) => setTimeout(resolve, 2000));
  console.log("✅ Pamphlet Created:", fullPayload);

  // Simulate sending
  if (formType === "Email") {
    console.log(`📧 Pamphlet sent to email: ${formData.email}`);
  } else if (formType === "Whatsapp") {
    console.log(`📲 Pamphlet sent to WhatsApp: ${formData.phone}`);
  }

  return true; // Success
};
